import type { NavigateTarget } from "@/types/agentFocus.type";

/**
 * Where a Navigate target lives in the app.
 *
 * The agent names a destination; this is the only place that knows its URL. It
 * relies on every surface being addressable by query string — which is why the
 * strategy and universe pages gained `?strategy` / `?section` / `?fact`. A
 * target that cannot be expressed as a link cannot be navigated to, and would
 * also not survive a refresh, so the two problems have one fix.
 */
export function targetToPath(target: NavigateTarget): string {
  switch (target.surface) {
    case "universe": {
      const params = new URLSearchParams();
      if (target.factId) params.set("fact", target.factId);
      const qs = params.toString();
      return `/dashboard/brand-universe${qs ? `?${qs}` : ""}`;
    }
    case "strategy": {
      const params = new URLSearchParams();
      if (target.strategyId) params.set("strategy", target.strategyId);
      if (target.section) params.set("section", target.section);
      const qs = params.toString();
      return `/dashboard/strategy${qs ? `?${qs}` : ""}`;
    }
    case "calendar": {
      if (target.year === undefined || target.month === undefined) {
        return "/dashboard/content-calendar";
      }
      const params = new URLSearchParams({
        year: String(target.year),
        month: String(target.month),
      });
      if (target.slotId) params.set("slot", target.slotId);
      else if (target.view === "review") params.set("view", "review");
      return `/dashboard/content-calendar?${params.toString()}`;
    }
    case "signals":
      return "/dashboard/market-signals";
    case "trends":
      return "/dashboard/trends";
    case "references":
      return "/dashboard/references";
    case "home":
      return "/dashboard";
  }
}
